var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6664 39.8121L59.672 39.823L59.6745 39.8281C59.8856 40.2504 59.8856 40.7496 59.6745 41.1718L59.672 41.1769L59.6664 41.1879L59.6479 41.224C59.6323 41.2544 59.6102 41.2971 59.5815 41.3513C59.5241 41.4596 59.4407 41.6142 59.3315 41.8083C59.1133 42.1962 58.7916 42.7435 58.3695 43.3971C57.5272 44.7013 56.2752 46.4441 54.636 48.1925C51.385 51.6603 46.4326 55.3333 40.0001 55.3333C33.5675 55.3333 28.6151 51.6603 25.3641 48.1925C23.7249 46.4441 22.4729 44.7013 21.6306 43.3971C21.2085 42.7435 20.8868 42.1962 20.6686 41.8083C20.5594 41.6142 20.476 41.4596 20.4186 41.3513C20.3899 41.2971 20.3678 41.2544 20.3522 41.224L20.3337 41.1879L20.3282 41.1769L20.3251 41.1708C20.1139 40.7485 20.1145 40.2504 20.3256 39.8281L20.3282 39.823L20.3337 39.8121L20.3522 39.7759C20.3678 39.7455 20.3899 39.7028 20.4186 39.6486C20.476 39.5403 20.5594 39.3857 20.6686 39.1916C20.8868 38.8037 21.2085 38.2564 21.6306 37.6028C22.4729 36.2986 23.7249 34.5559 25.3641 32.8074C28.6151 29.3396 33.5675 25.6666 40.0001 25.6666C46.4326 25.6666 51.385 29.3396 54.636 32.8074C56.2752 34.5559 57.5272 36.2986 58.3695 37.6028C58.7916 38.2564 59.1133 38.8037 59.3315 39.1916C59.4407 39.3857 59.5241 39.5403 59.5815 39.6486C59.6102 39.7028 59.6323 39.7455 59.6479 39.7759L59.6664 39.8121Z",
    fill: "white",
    stroke: "#8E8CEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 40.5C33.5 36.9101 36.4101 34 40 34C43.5898 34 46.5 36.9101 46.5 40.5C46.5 44.0899 43.5898 47 40 47C36.4101 47 33.5 44.0899 33.5 40.5Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.47a5a5d3ab1e21d0676e10a64bf4d8a6.svg";
export { ForwardRef as ReactComponent };